<template>
  <div class="classification" :style="{backgroundImage: `url(${imgBg})` }">
    <com-header />
    <div class="classification-list">
      <div class="classification-item" v-for="item in imgList" @click="jump(item.id)">
        <img :src="item.cover_image" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "classification",
  data(){
    return {
      imgList:[],
      imgStyle:1,
      imgBg:'',
      shopInfo: {}
    }
  },
  mounted(){
    this.shopInfo = JSON.parse(window.localStorage.getItem('shopInfo'))
    this.getCLassList({id: this.$route.query.id })
    this.getImgType()
    this.getImgBg()
  },
  methods:{
    getImgBg() {
      this.$get('/pc/shop/bgimg', {id: 'photostyle'}).then((res) => {
        this.imgBg = res.data.background_image
      }).catch((error) => {
      })
    },
    getCLassList(params) {
      this.$get('/pc/shop/secondClassify', params).then((res) => {
        this.imgList = res.data
      }).catch((error) => {
      })
    },
    getImgType(){
      this.$get('/pc/shop/categoryStyle', {}).then((res) => {
        this.imgStyle = res.data.style

      }).catch((error) => {
      })
    },
    jump(id){
      if(this.imgStyle === 1){
        this.$router.push(`classify?id=${id}`)
      }else {
        this.$router.push(`threeClass?id=${id}`)
      }

    }
  }
}
</script>

<style scoped lang="less">
.classification {
  height: 100vh;
  padding-top: 40px;
  box-sizing: border-box;
  background-size: cover;
  .classification-list {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 7.5vw;
    padding: 0 80px;
    .classification-item {
      width: 15.52vw;
      height: 27.6vw;
      margin-left: 10px;
      background: #FFF2DE;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .classification-item:hover{
      transform: scale(1.05);
      transition: all 0.3s;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/classification.vue